import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Table from "../Table/index.js";
import UpdateItemBtn from "../../buttons/UpdateItemBtn/index.js";
import UpdateServiceCredsPopup from "../../popups/UpdateServiceCredsPopup/index.js";
import {itemToUpdate} from "../../../redux/dataUploader/dataSlice.js";
import {SHOW_VOLUUM_COLUMNS} from "../../../constants/index.js";
import {USER_PROJECT, USER_ROLE} from "../../../constants/Auth/index.js";
import DeleteItemBtn from "../../buttons/DeleteItemBtn/index.js";
import ConfirmationPopup from "../../popups/ConfirmationPopup/index.js";
import Loader from "../../loaders/Loader/index.js";
import PostbackPopup from "../../popups/PostbackPopupWithoutConfig.js/index.js";
import {logOut} from "../../../redux/dataUploader/dataSlice.js";
import InfoPopup from "../../popups/InfoPopup/index.js";


const PreTableServiceCredentials = ({
                        rowData,
                        setNewDataStatus,
                        columnDefs,
                        setColumnDefs,
                        addPopupStatus,
                        setAddPopupStatus,
                        initialValues,
                        setInitialValues,
                        configData,
                        modifiedColumnsData,
                        onCountedNames,
                        addPopupWithConfigData,
                        isPopupType,
                        setPopupType,
                        additionalDefCol,
                        remarksList,
                        accountDetails,
                        setAccountDetails,
                        getTableRef,
                        affiliateNetworks,
                        isDeleteButton,
                        deletePostback,
                        anAccounts,
                        setIsTriggerUpdate,
                        setAccountsList,
                        setDeletePopupStatus,
                        deletePopupStatus,
                        projectsList,
                        usersList,
                        manageCompaniesIdList,
                        setReload,
                        reload,
                        totalRows,
                        currentPage,
                        perPage,
                        onPageChange,
                        onPerPageChange
    }) => {
    const dispatch = useDispatch();
    const role = localStorage.getItem(USER_ROLE);
    const projectName = localStorage.getItem(USER_PROJECT);
    const itemStatus = useSelector(state => state.dataUploader.voluumAlertItemStatus);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [deleteMessage, setDeleteMessage] = useState(false);
    const [deleteMessageText, setDeleteMessageText] = useState('');
    const [confirmationMessage, setConfirmationMessage] = useState(false);
    const [confirmationMessageText, setConfirmationMessageText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem("auth_token");
    
    // useEffect(() => {
    //     if(!deleteMessage || !confirmationMessage) {
    //         setReload(reload => reload + 1);
    //     }
    // }, [deleteMessage, confirmationMessage])

    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    useEffect(() => {
        let columns = [];
        if (rowData && rowData.length > 0) {
            columns = Object.keys(rowData[0])

            const colArr = modifiedColumnsData(columns);

            let newColArr;
            if(addPopupWithConfigData) {
                newColArr = colArr.map(el => {
                    if(role === 'admin') {
                        return ![...SHOW_VOLUUM_COLUMNS, 'method'].includes(el.field) ? {...el, hide: true} : el.type === 'number' ? {...el, comparator: (valueA, valueB) => valueA - valueB} : el.field === 'method' ? {...el, maxWidth: 330} : el;
                    } else {
                        return !SHOW_VOLUUM_COLUMNS.includes(el.field) ? {...el, hide: true} : el.type === 'number' ? {...el, comparator: (valueA, valueB) => valueA - valueB} : el;
                    }
                })
            } else {
                newColArr = colArr.map(el => {
                    if(el.field === 'voluum_account_id' || el.field === 'user_id' || el.field === 'manage_companies_id') {
                        return {...el, hide: true};
                    } else {
                        return el
                    }
                })
            }

            if (newColArr) {
                if (isDeleteButton) {
                    newColArr.push(
                        {
                            field: 'Edit',
                            headerName: '',
                            cellRenderer: (params) => {
                                return (
                                    <div className='btns-container'>
                                        <UpdateItemBtn onClick={() => openUpdatePopup(params)} newItem={false} />
                                    </div>
                                );
                            },
                            resizable: false,
                            editable: false,
                            minWidth: 50,
                            maxWidth: 50,
                            suppressSizeToFit: true
                        },
                    )
                } else if(!addPopupWithConfigData && (remarksList.includes(projectName) || role === 'admin')) {
                    newColArr.push(
                        {
                            field: 'Edit',
                            headerName: '',
                            cellRenderer: (params) => {
                                return (
                                    <div className='btns-container'>
                                        <UpdateItemBtn onClick={() => openUpdatePopup(params)} newItem={false} />
                                    </div>
                                );
                            },
                            resizable: false,
                            editable: false,
                            minWidth: 50,
                            maxWidth: 50,
                            suppressSizeToFit: true
                        }
                    )
                } else if(remarksList) {
                    if(remarksList.includes(projectName)) {
                        newColArr.push({
                            field: 'Edit',
                            headerName: '',
                            cellRenderer: (params) => {
                                return (
                                    <div className='btns-container'>
                                        <UpdateItemBtn onClick={() => openUpdatePopup(params)} newItem={false} />
                                    </div>
                                );
                            },
                            resizable: false,
                            editable: false,
                            minWidth: 50,
                            maxWidth: 50,
                            suppressSizeToFit: true
                        })
                    }
                }  else {
                    newColArr.push({
                        field: 'Edit',
                        headerName: '',
                        cellRenderer: (params) => {
                            return (
                                <div className='btns-container'>
                                    <UpdateItemBtn onClick={() => openUpdatePopup(params)} newItem={false} />
                                </div>
                            );
                        },
                        resizable: false,
                        editable: false,
                        minWidth: 50,
                        maxWidth: 50,
                        suppressSizeToFit: true
                    })
                }

                newColArr.push({
                        field: 'Delete',
                        headerName: '',
                        cellRenderer: (params) => {
                            return (
                                <div className='btns-container'>
                                    <DeleteItemBtn 
                                        onClick={() => {
                                            setItemToDelete(params);
                                            setDeletePopupStatus(true);
                                        }} 
                                        newItem={false} 
                                    />
                                </div>
                            );
                        },
                        resizable: false,
                        editable: false,
                        minWidth: 50,
                        maxWidth: 50,
                        suppressSizeToFit: true
                    })
            }
            setColumnDefs(newColArr);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowData])

    const onGridReady = params => {
        params.api.sizeColumnsToFit();
    };

    const openUpdatePopup = params => {
        setPopupType('updating')
        const {voluum_account_id, ...other} = params.data;
        if (params) dispatch(itemToUpdate(other));
        setAddPopupStatus(true);
    }

    const closePopup = () => {
        dispatch(itemToUpdate({}));
        setAddPopupStatus(false);
        if(itemStatus) setNewDataStatus(true);
    }

    const deleteAccount = async () => {
        if (!itemToDelete) return;
        
        try {
            setIsLoading(true);

            const res = await fetch(`${localStorage.getItem('apiUrl')}api/service-credential/delete/${itemToDelete.data.id}`, {
                method: 'DELETE',
                headers: { 
                    "Authorization": `Bearer ${token}` 
                }
            });
            // api call
            checkSession(res.status);

            const data = await res.json();
            
            if (data) {
                setDeletePopupStatus(false);
                setItemToDelete(null);
            }

            if(data?.status) {
                setDeleteMessage(true);
                setDeleteMessageText(data?.success?.message || `Account ${itemToDelete.data.name || ''} successfully deleted`); 
                // setAccountsList(data?.accounts?.data || []);
            } else {
                setDeleteMessage(true);
                setDeleteMessageText(data?.success?.message); 
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            setDeletePopupStatus(false);
            setItemToDelete(null);
            setIsLoading(false);
        }
    }

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
        autoHeight: true,
    }));

    if (isLoading) {
        return <div className='loading-wrap'><Loader/></div>
    }

    return (
        <>
            {rowData.length > 0 ?
                <Table
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={additionalDefCol ? {...defaultColDef, ...additionalDefCol} : defaultColDef}
                    onGridReady={onGridReady}
                    getTableRef={getTableRef}
                    totalRows={totalRows}
                    currentPage={currentPage}
                    perPage={perPage}
                    onPageChange={onPageChange}
                    onPerPageChange={onPerPageChange}
                /> : 
                <h3 className='no-data-title'>You need to have an account in order to see the information here.</h3>
            }

            {addPopupStatus?
                <UpdateServiceCredsPopup
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    accountDetails={accountDetails}
                    setAccountDetails={setAccountDetails}
                    remarksList={remarksList}
                    closePopup={closePopup}
                    isPopupType={isPopupType}
                    affiliateNetworks={affiliateNetworks}
                    anAccounts={anAccounts}
                    setIsTriggerUpdate={setIsTriggerUpdate}
                    setAccountsList={setAccountsList}
                    projectsList={projectsList}
                    usersList={usersList}
                    manageCompaniesIdList={manageCompaniesIdList}
                    setConfirmationMessage={setConfirmationMessage}
                    setConfirmationMessageText={setConfirmationMessageText}
                />
                : null
            }

            {deletePopupStatus ? 
                <ConfirmationPopup 
                    onCancel={() => setDeletePopupStatus(false)}
                    onConfirm={deleteAccount}
                    popupText="Please confirm delete selected data?"
                />
                : null
            }
            {deleteMessage ?
                <InfoPopup 
                    text={deleteMessageText}
                    onClose={() => setReload(reload => reload + 1)}
                    onConfirm={() => setReload(reload => reload + 1)}
                />
                : null
            }
            {confirmationMessage ?
                <InfoPopup 
                    text={confirmationMessageText}
                    onClose={() => setReload(reload => reload + 1)}
                    onConfirm={() => setReload(reload => reload + 1)}
                />
                : null
            }
        </>
    );
};

export default PreTableServiceCredentials;
